// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-section h2{margin-top:0;margin-bottom:1rem;font-size:14px;font-weight:500}\n", ""]);
// Exports
module.exports = exports;
